import Product = FBInstant.Product;
import Purchase = FBInstant.Purchase;
import { ShopProductIDs } from '../Config/Shop';
import { waitForMs } from '../Utils/AsyncUtils';
import { IPurchaseResult, ISDKpayments, PurchaseStatus } from './ISDKpayments';

export class SDKlocalpayments implements ISDKpayments {
    public readonly enabled: boolean;
    private readonly purchases: Purchase[];
    private readonly catalog: Product[];

    constructor(enabled: boolean = true) {
        this.enabled = enabled;
        this.purchases = [];
        this.catalog = [
            {
                title: 'Starter Pack',
                productID: ShopProductIDs.StarterPack,
                price: '160,0€',
                priceCurrencyCode: 'EUR',
            },
            {
                title: 'VIP Pack',
                productID: ShopProductIDs.VipPack,
                price: '160,0€',
                priceCurrencyCode: 'EUR',
            },
            {
                title: 'Big Pack',
                productID: ShopProductIDs.BigPack,
                price: '16,0€',
                priceCurrencyCode: 'EUR',
            },
            {
                title: 'Coins S',
                productID: ShopProductIDs.CoinsS,
                price: '0',
                priceCurrencyCode: 'EUR',
            },
            {
                title: 'Coins M',
                productID: ShopProductIDs.CoinsM,
                price: '0',
                priceCurrencyCode: 'EUR',
            },
            {
                title: 'Coins L',
                productID: ShopProductIDs.CoinsL,
                price: '0',
                priceCurrencyCode: 'EUR',
            },
            {
                title: 'Coins XL',
                productID: ShopProductIDs.CoinsXL,
                price: '0',
                priceCurrencyCode: 'EUR',
            },
        ];
    }

    public async consumePurchase(purchaseToken: string): Promise<boolean> {
        const index = this.purchases.findIndex((x: Purchase) => x.purchaseToken === purchaseToken);
        this.purchases.splice(index, 1);
        await waitForMs(500);
        return true;
    }

    public async getCatalog(): Promise<Product[]> {
        await waitForMs(500);
        return this.catalog;
    }

    public async getPurchases(): Promise<Purchase[]> {
        await waitForMs(500);
        return this.purchases;
    }

    public async purchase(productID: string): Promise<IPurchaseResult> {
        await waitForMs(500);
        const purchase = {
            paymentID: Math.random().toString(),
            productID,
            purchaseTime: Date.now().toString(),
            purchaseToken: Math.random().toString(),
            signedRequest: Math.random().toString(),
        };
        this.purchases.push();
        return { status: PurchaseStatus.Success, purchase };
    }
}
